import '@common/analytics';
import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';

import { BrowserRouter as Router } from 'react-router-dom';

import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import SessionProvider from '@common/contexts/session';

import BranchIndicator from '@common/components/branch-indicator/branch-indicator';
import apolloClient from '@common/apollo-client';

import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';

/* Import common styles first */
import theme from '@styles/theme';
import './aware.css';

import packageJSON from '@package';
import logException from '@util/js-error';
import { configureStore } from '@common/store';
import BreadcrumbsOverrideLinkProvider from '@common/contexts/breadcrumb-link';
import { DrawerStateProvider } from '@common/components/navigation-drawer/drawer-state-context';
import reducers from './reducers';

import App from './app';

dayjs.extend(LocalizedFormat);

/* Exposes version number from package.json as a global variable. */
window.EDP_VERSION = packageJSON.version;

const store = configureStore(reducers);

const basename = `/${window.location.pathname.split('/')[1]}`;

try {
  const root = createRoot(document.getElementById('root'));
  root.render(
    <ApolloProvider client={apolloClient}>
      <SessionProvider app="DAT,RST,SYS" includePermissions>
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Router basename={basename}>
                <BreadcrumbsOverrideLinkProvider>
                  <BranchIndicator />
                  <DrawerStateProvider>
                    <App />
                    <div id="contentClarifierRoot" />
                    <div id="modalRoot" />
                    <div id="snackbarRoot" />
                    <div id="printPortal" />
                  </DrawerStateProvider>
                </BreadcrumbsOverrideLinkProvider>
              </Router>
            </LocalizationProvider>
          </ThemeProvider>
        </Provider>
      </SessionProvider>
    </ApolloProvider>
  );
} catch (ex) {
  logException(ex);
}
